import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { creditCardItemRepository } from '@webapp/modules/accounts-payable/data-access/repositories/CreditCardItemRepository'
import {
  CREDIT_CARD_ITEM_LIST_BASE_KEY,
  CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY,
} from '@webapp/modules/accounts-payable/query-configs/creditCardItemQueries'

export const useMutateUnarchiveCreditCardItem = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, { id: number }>({
    mutationFn: ({ id }) => creditCardItemRepository.setArchived(id, false),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CREDIT_CARD_ITEM_LIST_BASE_KEY,
      })
      queryClient.invalidateQueries({
        queryKey: CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY,
      })
    },
  })

  return {
    unarchive: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    error: mutation.error,
  }
}
